<template>
    <div>
        <v-layout row wrap fill-height>
            <v-flex xs12 fill-height>
                <v-card flat class="preroll-player" width="100%" :style="{'height': playerHeight}"></v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import Artplayer from 'artplayer';
export default {
    name: "PrerollPlayer",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            player: null,
            isEnded: false,
        }
    },
    mounted() {
        this.initialisePlayer();
    },

    computed: {
        playerHeight() {
            // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
            return this.meta.isFullScreenMode ? '98vh' :'600px'
        }
    },
    methods: {
        async initialisePlayer() {
            /**
             * 1. Load all default configurations of player
             * 2. Configure all event listeners with its listners
             * 3. Add watermark to player
             */
            await this.loadPlayer();
            // this.addWaterMark(this.player);
            this.configureAllEventListeners(this.player);
        },

        loadPlayer() {
            //FIXME:: Mute and auto play case need to be handle
            let _this = this;
            return this.player = new Artplayer({
                container: '.preroll-player',
                autoMini: true,
                pip: true,
                isLive: true, // Use this flag to disable seeking
                hotkey: false, // Stop hotkeys to skip video
                url: this.meta.pre_roll,
                fullscreen: true,
                 whitelist:["*"],
                fullscreenToggle: true,
                autoplay:true,
                pause:false,
                customType: {
                    m3u8: function (video, url) {
                        _this.initialiseHlsPlayer(video, url);
                    },
                },
            })
        },

        /**
         * This function is responsible to handeling HLS initialization
         */
        initialiseHlsPlayer(video, url) {
            var hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(video);
        },

        /**
         * This function is responsible to add company logo as
         * a watermark
         */
        addWaterMark(playerInstance) {
            playerInstance.layers.add({
                html: `<img style="width: 100px" src="${this.meta.company_logo}">`,
                style: {
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    opacity: '.9',
                },
            });
        },

        /**
         * Configure all event listners with its handeler
         */
        configureAllEventListeners(playerInstance) {
            let _this = this;
            //playerInstance.on("ready",() => {_this.onReady(playerInstance, playerInstance.currentTime)});
            playerInstance.on("video:ended",() => {_this.onVideoEnd(playerInstance)});
            playerInstance.on("video:pause",() => {_this.pauseHandler(playerInstance) });
        },
        /**
         * Player Ready State handeler
         */
        onReady(playerInstance, currentTime) {
            //Handel player ready state
        },

        //Handel video ready state
        onVideoEnd(playerInstance) {
            //need to destroy otherwise event listener causes problem
            playerInstance.destroy();
            this.$emit('preRollEnded',playerInstance)
        },

        //in case of preroll we do not allow pause
        //so calling the play function forcefully
        //if someone tries to pause
        pauseHandler(playerInstance){
            playerInstance.play();
        }


    }
}
</script>
<style scoped>

</style>
